/**
 * 다국어 시스템 메인 진입점
 * 
 * 사용법:
 * import { t } from '../i18n';
 * const text = t('calendar.today', 'ko'); // '오늘'
 * 
 * 또는 훅 사용:
 * import { useTranslation } from '../i18n/useTranslation';
 * const { t } = useTranslation();
 * const text = t('calendar.today'); // 현재 사용자 언어로 번역
 */

import ko from './translations/ko';
import en from './translations/en';
import fr from './translations/fr';

const translations = { ko, en, fr };

/**
 * 번역 함수
 * @param {string} key - 번역 키 (예: 'calendar.today', 'reservation.status.pending')
 * @param {string} lang - 언어 코드 ('ko', 'en', 'fr')
 * @param {Object} params - 치환 파라미터 (예: { count: 5 })
 * @returns {string} 번역된 텍스트
 */
export const t = (key, lang = 'ko', params = {}) => {
    // 점(.)으로 구분된 키를 파싱
    const keys = key.split('.');
    let text = translations[lang] || translations.ko;

    // 중첩된 객체에서 값 찾기
    for (const k of keys) {
        text = text?.[k];
        if (text === undefined) break;
    }

    // 키를 찾지 못하면 기본 언어(한국어)에서 찾기
    if (text === undefined) {
        text = translations.ko;
        for (const k of keys) {
            text = text?.[k];
            if (text === undefined) break;
        }
    }

    // 그래도 없으면 키 자체 반환
    if (text === undefined) {
        return key;
    }

    // 파라미터 치환
    if (typeof text === 'string' && Object.keys(params).length > 0) {
        Object.entries(params).forEach(([paramKey, value]) => {
            text = text.replace(new RegExp(`\\{${paramKey}\\}`, 'g'), String(value));
        });
    }

    return text;
};

/**
 * 사용 가능한 언어 목록
 */
export const LANGUAGES = {
    ko: '한국어',
    en: 'English',
    fr: 'Français'
};

/**
 * 기본 언어
 */
export const DEFAULT_LANGUAGE = 'ko';

export default translations;
